import { render } from "./AnglePopup.vue?vue&type=template&id=49cfdf83&scoped=true"
import script from "./AnglePopup.vue?vue&type=script&lang=js"
export * from "./AnglePopup.vue?vue&type=script&lang=js"

import "./AnglePopup.vue?vue&type=style&index=0&id=49cfdf83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cfdf83"]])

export default __exports__